import { PageLayout } from '~/components/PageLayout/PageLayout';
import { formatResultWeight } from '~/utils/weight';
import { Table } from '~/components/Table/Table';
import { PersonalBestEntry } from '~/apis/ssf';
import { formatPoints } from '~/utils/points';
import { Fragment } from 'react/jsx-runtime';

interface Props {
  pbs?: PersonalBestEntry[];
  isLoading: boolean;
}

function Row({ pb }: { pb: PersonalBestEntry }) {
  return (
    <Table.Row>
      <Table.Col>{pb.competition_type.description}</Table.Col>
      <Table.Col>{pb.squat ? formatResultWeight(pb.squat.result) : '-'}</Table.Col>
      <Table.Col>{pb.benchpress ? formatResultWeight(pb.benchpress.result) : '-'}</Table.Col>
      <Table.Col>{pb.deadlift ? formatResultWeight(pb.deadlift.result) : '-'}</Table.Col>
      <Table.Col>{pb.total ? formatResultWeight(pb.total.result) : '-'}</Table.Col>
      <Table.Col>{pb.points?.result ? formatPoints(pb.points?.result) : '-'}</Table.Col>
    </Table.Row>
  );
}

export function PersonalBestTable({ pbs: personal_bests, isLoading }: Props) {
  return (
    <Fragment>
      <PageLayout.SubHeading>Personbästa</PageLayout.SubHeading>

      <Table>
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Tävlingstyp</Table.Col>
            <Table.Col as="th">Knäböj</Table.Col>
            <Table.Col as="th">Bänk</Table.Col>
            <Table.Col as="th">Marklyft</Table.Col>
            <Table.Col as="th">Total</Table.Col>
            <Table.Col as="th" tooltip="Poängsystem: IPFGL">
              Poäng
            </Table.Col>
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? <Table.Loading cols={6} /> : personal_bests?.map((pb, i) => <Row pb={pb} key={i} />)}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
